// PATH: src/components/ui/EmptyState.tsx
import * as React from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  dense?: boolean;
}

/** Ce qu'on montre quand une liste est vide : quoi, pourquoi, que faire. */
export const EmptyState: React.FC<Props> = ({ icon, title, description, action, dense }) => (
  <Box sx={{ textAlign: "center", py: dense ? 3 : 6, px: 2, color: "text.secondary" }}>
    {icon && (
      <Box
        sx={{
          display: "inline-flex",
          p: 1.25,
          mb: 1.5,
          borderRadius: 3,
          bgcolor: "action.hover",
          color: "text.secondary",
          "& svg": { fontSize: 26 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography variant="subtitle1" color="text.primary">
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ mt: 0.5, maxWidth: 440, mx: "auto" }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 2 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
